import React, { useEffect } from "react";
import {
  Grid,
  Typography,
  Box,
  InputLabel,
  FormControl,
  InputAdornment,
  Button,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import styles from "../../../../styles/global-styles";
import NumberFormatCustom from "../../../stateless/NumberFormatCustom";
import Transition from "../../../stateless/Transition";
import ColorOptionForm from "../../../shared/selects/color-select/ColorOptionForm";
import ModalAddColor from "../../../shared/selects/color-select/ModalAddColor";
import { ProviderService } from "../../../../services/provider.service";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "auto", // Fix IE 11 issue.
  },
  formControl: {
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      width: 240,
    },
    [theme.breakpoints.down("sm")]: {
      width: 250,
    },
    minWidth: 200,
    width: 320,
  },
  label: {
    marginBottom: "1.5vh",
  },
  box: {
    marginTop: "20px",
  },
  backgroundIcon: styles.backgroundIcon,
  addColorButton: styles.addColorButton,
  rightButton: styles.buttonRightHeader,
}));

const HalfMovileForm = ({
  open,
  onClose,
  formMovileCompleted,
  addAlert,
  detailAlert,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [productCompleted, setProductCompleted] = React.useState({});
  const [openModal, setOpenModal] = React.useState(false);
  const [providerArray, setProviderArray] = React.useState([]);
  const [hasError, setHasError] = React.useState(false);

  useEffect(() => {
    (async function fetchData() {
      try {
        const { data } = await ProviderService.getAllProviders();
        setProviderArray(data);
      } catch (error) {
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    })();
  }, []);

  const handleInputText = ({ target: { name, value } }) => {
    if (name === "providerId" && value) setHasError(false);
    setProductCompleted({ ...productCompleted, [name]: value });
  };

  const handleCloseModal = (openModal) => setOpenModal(openModal);

  const handleColorSelect = (color) => {
    setProductCompleted({ ...productCompleted, color });
  };

  const handleClose = () => onClose();

  const handleSubmitForm = (event) => {
    setProductCompleted({
      ...productCompleted,
    });
    formMovileCompleted(productCompleted);
    setProductCompleted({});
  };

  return (
    <Dialog
      open={open}
      maxWidth={"lg"}
      onClose={handleClose}
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Nuevo stock
      </DialogTitle>
      <DialogContent>
        <ValidatorForm
          noValidate
          onKeyPress={(event) => {
            if (event.which === 13 /* Enter */) {
              event.preventDefault();
            }
          }}
          className={classes.form}
          onSubmit={(e) => handleSubmitForm(e)}
          method="POST"
          onError={() => {
            if (productCompleted.providerId === undefined) {
              setHasError(true);
            }
          }}
        >
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
          >
            <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
              <Button
                variant="contained"
                className={classes.addColorButton}
                style={{ marginBottom: -28 }}
                color="primary"
                onClick={() => setOpenModal(true)}
              >
                Agregar color
              </Button>
              <Box>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel
                    shrink
                    id="demo-simple-select-placeholder-label-label"
                  >
                    Color del equipo
                  </InputLabel>

                  <ColorOptionForm
                    colorSelected={handleColorSelect}
                  ></ColorOptionForm>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Capacidad
                </Typography>
                <TextValidator
                  name="capacity"
                  value={productCompleted.capacity || ""}
                  validators={["required"]}
                  onChange={(e) => handleInputText(e)}
                  errorMessages={["La capacidad es requerida"]}
                  variant="outlined"
                  InputProps={{
                    maxLength: 8,
                    startAdornment: (
                      <InputAdornment position="start">RAM</InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">GB</InputAdornment>
                    ),
                  }}
                ></TextValidator>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Costo
                </Typography>
                <TextValidator
                  name="cost"
                  value={productCompleted.cost || ""}
                  onChange={(e) => handleInputText(e)}
                  variant="outlined"
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                  }}
                ></TextValidator>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Precio
                </Typography>
                <TextField
                  value={productCompleted.price || ""}
                  variant="outlined"
                  onChange={(e) => handleInputText(e)}
                  name="price"
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Descuento
                </Typography>
                <TextValidator
                  name="discount"
                  value={productCompleted.discount || ""}
                  onChange={(e) => handleInputText(e)}
                  placeholder="Ingresar monto o dejar en blanco"
                  // errorMessages={["El descuento es requerido"]}
                  variant="outlined"
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                  }}
                ></TextValidator>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={4}
              xl={4}
              style={{ marginBottom: 20 }}
            >
              <Box>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  error={hasError}
                >
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Proveedor
                  </Typography>
                  <Select
                    disabled={false}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="providerId"
                    required
                    value={productCompleted.providerId || ""}
                    onChange={(e) => handleInputText(e)}
                  >
                    {providerArray.map((product, id) => {
                      return (
                        <MenuItem key={id} value={product.id || ""}>
                          {product.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {hasError && (
                    <FormHelperText>
                      Es necesario seleccionar un proveedor
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
              <Box className={classes.inputBoxSpace}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Lote
                </Typography>
                <TextValidator
                  name="lote"
                  value={productCompleted.lote || ""}
                  validators={["required"]}
                  onChange={(e) => handleInputText(e)}
                  errorMessages={["El lote es requerido"]}
                  variant="outlined"
                ></TextValidator>
              </Box>
            </Grid>

            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item>
                <Button
                  color="primary"
                  style={{ marginRight: 50, width: 150 }}
                  onClick={handleClose}
                >
                  Cancelar
                </Button>
              </Grid>
              <Grid item>
                <Button
                  className={classes.rightButton}
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ fontSize: 14, width: 150 }}
                  endIcon={
                    <ArrowRightAltIcon
                      className={classes.backgroundIcon}
                      color="primary"
                    ></ArrowRightAltIcon>
                  }
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </ValidatorForm>

        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          fullScreen={fullScreen}
          open={openModal}
          onClose={() => setOpenModal(false)}
          aria-labelledby="form-dialog-title"
        >
          <DialogContent style={{ overflow: "hidden" }}>
            <ModalAddColor openModal={handleCloseModal}></ModalAddColor>
          </DialogContent>
        </Dialog>
      </DialogContent>
    </Dialog>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(HalfMovileForm);
